// Mock data for Brazilian Lawyers Marketplace

export const CATEGORIES = [
  { slug: 'trabalhista', name: 'Trabalhista', icon: 'Briefcase' },
  { slug: 'civel', name: 'Cível', icon: 'Scale' },
  { slug: 'criminal', name: 'Criminal', icon: 'Gavel' },
  { slug: 'familia', name: 'Família e Sucessões', icon: 'Users' },
  { slug: 'empresarial', name: 'Empresarial', icon: 'Building2' },
  { slug: 'tributario', name: 'Tributário', icon: 'Landmark' },
  { slug: 'previdenciario', name: 'Previdenciário', icon: 'ShieldCheck' },
  { slug: 'consumidor', name: 'Consumidor', icon: 'ShoppingBag' },
  { slug: 'imobiliario', name: 'Imobiliário', icon: 'Home' },
  { slug: 'digital', name: 'Direito Digital', icon: 'Laptop' },
  { slug: 'ambiental', name: 'Ambiental', icon: 'Leaf' },
  { slug: 'medico', name: 'Direito Médico', icon: 'Stethoscope' },
];

export const CITIES = [
  { slug: 'sao-paulo', name: 'São Paulo', state: 'SP', count: 328, lat: -23.5505, lng: -46.6333 },
  { slug: 'rio-de-janeiro', name: 'Rio de Janeiro', state: 'RJ', count: 214, lat: -22.9068, lng: -43.1729 },
  { slug: 'belo-horizonte', name: 'Belo Horizonte', state: 'MG', count: 142, lat: -19.9167, lng: -43.9345 },
  { slug: 'brasilia', name: 'Brasília', state: 'DF', count: 189, lat: -15.8267, lng: -47.9218 },
  { slug: 'curitiba', name: 'Curitiba', state: 'PR', count: 121, lat: -25.4284, lng: -49.2733 },
  { slug: 'porto-alegre', name: 'Porto Alegre', state: 'RS', count: 104, lat: -30.0346, lng: -51.2177 },
  { slug: 'pelotas', name: 'Pelotas', state: 'RS', count: 0, lat: -31.7654, lng: -52.3376 },
  { slug: 'salvador', name: 'Salvador', state: 'BA', count: 87, lat: -12.9714, lng: -38.5014 },
  { slug: 'fortaleza', name: 'Fortaleza', state: 'CE', count: 76, lat: -3.7319, lng: -38.5267 },
  { slug: 'recife', name: 'Recife', state: 'PE', count: 68, lat: -8.0476, lng: -34.8770 },
  { slug: 'manaus', name: 'Manaus', state: 'AM', count: 42, lat: -3.1190, lng: -60.0217 },
  { slug: 'goiania', name: 'Goiânia', state: 'GO', count: 54, lat: -16.6869, lng: -49.2648 },
  { slug: 'florianopolis', name: 'Florianópolis', state: 'SC', count: 63, lat: -27.5954, lng: -48.5480 },
  { slug: 'campinas', name: 'Campinas', state: 'SP', count: 71, lat: -22.9099, lng: -47.0626 },
  { slug: 'vitoria', name: 'Vitória', state: 'ES', count: 39, lat: -20.3155, lng: -40.3128 },
  { slug: 'natal', name: 'Natal', state: 'RN', count: 28, lat: -5.7945, lng: -35.2110 },
  { slug: 'joao-pessoa', name: 'João Pessoa', state: 'PB', count: 24, lat: -7.1195, lng: -34.8450 },
  { slug: 'barueri', name: 'Barueri', state: 'SP', count: 1, lat: -23.5064, lng: -46.8508 },
];
